import { z } from "zod";
import { slugifyString } from "../helpers/utilities.js";
const KNOWLEDGE_RETRIEVAL_TOOL_ID = "alpharun:knowledge";
const KNOWLEDGE_RETRIEVAL_TOOL_NAME = "knowledge";
const KNOWLEDGE_RETRIEVAL_TOOL_GENERIC_DESCRIPTION = "Retrieves a knowledge base document by its name. Use this tool when you need to look up information from the company's knowledge base to help answer a caller's question.";
const knowledgeRetrievalToolInputSchema = z.object({
  document_name: z.string().describe("The name of the document to retrieve")
});
function buildKnowledgeBaseDocumentName(document) {
  return slugifyString(document.title || "Untitled document");
}
function findKnowledgeBaseDocumentByName(documents, documentName) {
  return documents.find(
    (doc) => buildKnowledgeBaseDocumentName(doc) === documentName
  );
}
function buildKnowledgeRetrievalToolContent(document) {
  const title = document.title || "Untitled document";
  const body = document.body || "No content available for this document.";
  return `# ${title}

${body}`;
}
function buildKnowledgeRetrievalToolDescription(documents) {
  if (documents.length === 0) {
    return `${KNOWLEDGE_RETRIEVAL_TOOL_GENERIC_DESCRIPTION}

Note: No documents are currently available in the knowledge base.`;
  }
  const documentItems = documents.map((doc) => {
    const name = buildKnowledgeBaseDocumentName(doc);
    const description = doc.description || "No description available";
    return `- ${name}: ${description}`;
  });
  return `${KNOWLEDGE_RETRIEVAL_TOOL_GENERIC_DESCRIPTION}

Available documents:
${documentItems.join("\n")}`;
}
function buildKnowledgeBaseContentForPrompt(documents) {
  if (documents.length === 0) {
    return "";
  }
  const sections = documents.map((doc) => {
    const title = doc.title || "Untitled document";
    const body = doc.body || "No content available for this document.";
    return `## ${title}

${body}`;
  });
  return `# Knowledge Base

The following knowledge base content is provided for your reference. Use this information to answer caller questions accurately and consistently.

${sections.join("\n\n---\n\n")}`;
}
function buildKnowledgeRetrievalToolParametersSchema() {
  const jsonSchema = z.toJSONSchema(knowledgeRetrievalToolInputSchema);
  const { $schema, ...schema } = jsonSchema;
  return schema;
}
export {
  KNOWLEDGE_RETRIEVAL_TOOL_GENERIC_DESCRIPTION,
  KNOWLEDGE_RETRIEVAL_TOOL_ID,
  KNOWLEDGE_RETRIEVAL_TOOL_NAME,
  buildKnowledgeBaseContentForPrompt,
  buildKnowledgeBaseDocumentName,
  buildKnowledgeRetrievalToolContent,
  buildKnowledgeRetrievalToolDescription,
  buildKnowledgeRetrievalToolParametersSchema,
  findKnowledgeBaseDocumentByName,
  knowledgeRetrievalToolInputSchema
};
//# sourceMappingURL=knowledgeRetrievalTool.js.map
